<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasModuleGerencia"
             color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             link to="/cadastro-compra">
        <v-icon left>mdi-plus</v-icon>
        Compras
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-listagem-compra-filtro @change="emitChange"/>
      <px-search-text :label="labelSearchBox"
                      class="rounded-tag-small"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListagemCompraFiltro from './ListagemCompraFiltro.vue';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasIntegracaoAtiva', 'hasModuleGerencia']),
    selectedStatus: {
      get() {
        return this.$store.getters['listagemCompra/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemCompra/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemCompra/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemCompra/searchText', searchText);
      },
    },
    labelSearchBox() {
      return this.hasIntegracaoAtiva ? 'Busque por código ou número da OC' : 'Busque por código';
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'RASCUNHO',
          description: 'Rascunhos',
          value: ['RASCUNHO'],
        },
        {
          id: 'APROVADAS',
          description: 'Aprovadas',
          value: ['APROVADA'],
        },
        {
          id: 'ABERTAS',
          description: 'Abertas',
          value: ['PENDENTE_COMPRADOR', 'PENDENTE_FORNECEDOR'],
        },
        {
          id: 'ELABORACAO',
          description: 'Em elaboração',
          value: ['ELABORACAO'],
        },
        {
          id: 'CANCELADAS',
          description: 'Canceladas',
          value: ['CANCELADA'],
        },
        {
          id: 'RECUSADAS',
          description: 'Recusadas',
          value: ['RECUSADA'],
        },
      ],
    };
  },
  created() {
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
  components: {
    pxListagemCompraFiltro: ListagemCompraFiltro,
  },
};
</script>
